// extracted by mini-css-extract-plugin
export default {"content":"DP2x_x","summary":"E23mPr"};